import dayjs from "dayjs";
import {
  screenWidthMultiplier
} from "./../constants";

export const getCols = (zoom: number, date: dayjs.Dayjs) => {
  switch(zoom){
    case 1:
      return dayjs(date).daysInMonth();
      break;
    case 3:
      return dayjs(date.add(5, 'month').endOf('month')).diff(dayjs(date.startOf('month')), 'week');
      break;
    case 4:
      return dayjs(date.add(12, 'month').endOf('month')).diff(dayjs(date.startOf('month')), 'month');
      break;
    default:
      return dayjs(date.add(2, 'month').endOf('month')).diff(dayjs(date.startOf('month')), 'week');
      break;
  }
  // const wrapperWidth = document.getElementById(outsideWrapperId)?.clientWidth || 0;
  // const componentWidth = wrapperWidth - leftColumnWidth;
  // switch (zoom) {
  //   case 1:
  //     return Math.ceil(componentWidth / dayWidth) * screenWidthMultiplier;
  //   case 2:
  //     return Math.ceil(componentWidth / zoom2ColumnWidth) * screenWidthMultiplier;
  //   default:
  //     return Math.ceil(componentWidth / weekWidth) * screenWidthMultiplier;
  // }
};

export const getVisibleCols = (zoom: number, date: dayjs.Dayjs) => getCols(zoom, date) / screenWidthMultiplier;
